import { useEffect, useState } from 'react'
import Router from '@app/Router'
import { BrowserRouter } from 'react-router'
import MaintenancePage from '@pages/MaintenancePage'

const MAINTENANCE_ENABLED = import.meta.env.VITE_APP_MAINTENANCE_MODE === 'true'
const STORAGE_KEY = 'maintenance'
const STORAGE_OFF = 'off'
const BYPASS_PHRASE = 'maintenance'

function isMaintenanceBypassed() {
  return localStorage.getItem(STORAGE_KEY) === STORAGE_OFF
}

function App() {
  const [showMaintenance, setShowMaintenance] = useState(
    () => MAINTENANCE_ENABLED && !isMaintenanceBypassed()
  )

  useEffect(() => {
    if (!showMaintenance) return

    let buffer = ''

    const onKeyDown = (e) => {
      if (e.ctrlKey || e.metaKey || e.altKey || e.key.length !== 1) return

      buffer = (buffer + e.key.toLowerCase()).slice(-BYPASS_PHRASE.length)

      if (buffer === BYPASS_PHRASE) {
        localStorage.setItem(STORAGE_KEY, STORAGE_OFF)
        setShowMaintenance(false)
      }
    }

    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [showMaintenance])

  if (showMaintenance) {
    return (
      <main>
        <MaintenancePage />
      </main>
    )
  }

  return (
    <BrowserRouter>
      <main>
        <Router/>
      </main>
    </BrowserRouter>
  )
}

export default App
